import { string } from 'prop-types'
import { kuiperClassNames } from '@opallabs/kuiper'
import { Button } from '@opallabs/lapidary'

const GenericError = ({ message = 'We’re sorry—something went wrong.' }) => (
  <section
    className={kuiperClassNames(
      'error-display-week-view',
      'error-display-generic'
    )}
  >
    <h2>{message}</h2>
    <Button
      buttonText="Reload"
      name="reload"
      onClick={() => window.location.reload(true)}
    />
  </section>
)

GenericError.propTypes = {
  message: string,
}

export default GenericError
